import React, {FC, useEffect, useState} from 'react';
import {alpha, Typography} from '@mui/material';
import {useTranslation} from "react-i18next";
import Avatar from "@mui/material/Avatar";
import {WinnerEntry} from "../../../util/hooks/useWishCountdown";
import Box from "@mui/material/Box";
import {Theme, useTheme} from "@mui/material/styles";
import {SxProps} from "@mui/system";

interface IProps {
    thumbnail: string;
    tickets: WinnerEntry[];
    winner: WinnerEntry | null
    color: string
    sx?: SxProps<Theme>
}

const CardWinnerPicker: FC<IProps> = (props) => {
    const {t} = useTranslation();
    const [currentIndex, setCurrentIndex] = useState(0);
    const theme = useTheme()

    // Cycle through the array until a winner is set.
    useEffect(() => {
        if (!props.winner && props.tickets.length > 0) {
            const intervalId = setInterval(() => {
                setCurrentIndex(prevIndex => (prevIndex + 1) % props.tickets.length);
            }, 200); // update every 200ms
            return () => clearInterval(intervalId);
        }
    }, [props.winner, props.tickets.length]);

    // Display the cycling entry or the final winner.
    const currentEntry = props.winner || props.tickets[currentIndex];

    return (
        <Box sx={{
            background: alpha(theme.palette.primary.main, .2),
            backdropFilter: 'blur(5px)',
            py: 1,
            width: "100%",
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            position: "relative",
            textAlign: "center",
            ...props.sx
        }}>

            {props.winner &&
                <Typography variant="subtitle1" sx={{color: props.color}} fontWeight={600} fontSize="1.5rem">
                {t('winner')}:
                </Typography>}
            {currentEntry && (
                <>
                    <Avatar sx={{width: 56, height: 56, justifySelf: 'center', mt: 0.5}}
                            slotProps={{
                                img: {
                                    loading: 'eager',
                                    decoding: 'async',
                                    fetchPriority: 'high'
                                }
                            }}
                            alt={currentEntry.recipient_name ?? currentEntry.full_name}
                            src={currentEntry.recipient_name ? '' : currentEntry.profile_picture}/>
                    <Typography variant="body1" sx={{color: props.color}} fontSize="1.5rem">
                        {currentEntry.recipient_name ?? currentEntry.full_name}
                    </Typography>
                    <Typography variant="body1" sx={{color: props.color}} fontSize="1rem">
                        {currentEntry.code}
                    </Typography>
                </>
            )}
        </Box>
    );
};

export default CardWinnerPicker;
